import { Box } from "@mui/material";
import { Outlet } from "react-router";

import UserGuideSideMenu from "@/components/UserGuide/UserGuideSideMenu";
import "@/components/UserGuide/UserGuide.css";

function UserGuide() {
  return (
    <Box sx={{ display: "flex" }} id="user-guide-layout">
      <Box id="user-guide-side-menu-container">
        <UserGuideSideMenu />
      </Box>
      <Box sx={{ flexGrow: 1 }} id="user-guide-content-container">
        <Outlet />
      </Box>
    </Box>
  );
}

export default UserGuide;
